import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0 font-heading">
        404
      </h1>
      <div className="relative z-10">
        <h2 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-900">
          Страница не найдена
        </h2>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">
          Возможно, вы перешли по неправильной ссылке
        </p>
        <Link
          to="/"
          className="inline-block mt-6 px-6 py-3 rounded-full bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          Вернуться на главную
        </Link>
      </div>
    </div>
  );
}